import React from 'react';
import { OnChangeValue } from 'react-select';
import { Controller, useFormContext } from 'react-hook-form';
import { Typo, FormGroup, TextField, SingleSelect } from 'components/primitives';
import { Box, Grid, Divider, useTheme } from '@mui/material';
import useStyles from './IncidentAddFormModalView.styels';

const IncidentAddFormModalView: React.FC = () => {
  const theme = useTheme();
  const classes = useStyles();
  const { control } = useFormContext();

  return (
    <Box className={classes.container}>
      <Typo variant='h5' fontWeight={600} sx={{ pb: theme.spacing(2) }}>
        Add new incident
      </Typo>
      <Grid container spacing={2}>
        <Grid item xs={12} lg={12}>
          <Controller
            name={'name'}
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <FormGroup label='Name' error={error}>
                <TextField
                  error={Boolean(error)}
                  placeholder='Incident name'
                  value={value}
                  onChange={onChange}
                />
              </FormGroup>
            )}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <Controller
            name={'description'}
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <FormGroup label='Description' error={error}>
                <textarea
                  className={classes.textarea}
                  // defaultValue={emailTemplate}
                  spellCheck='false'
                  rows={10}
                  value={value}
                  onChange={onChange}
                />
              </FormGroup>
            )}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default IncidentAddFormModalView;
